<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
body {
  padding: 0px;
  margin: 0px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

/* nav a {
  text-decoration: none;
} */
</style>
